export default __webpack_public_path__ + "static/media/hero-tile.8f9ca766.png";